UC.views.AccountLogon = Backbone.View.extend({

  initialize: function() {
    new UC.partials.SessionsForm();
  }

});
